import { render, staticRenderFns } from "./u-tab-dot.vue?vue&type=template&id=714d1266&scoped=true&"
import script from "./u-tab-dot.vue?vue&type=script&lang=js&"
export * from "./u-tab-dot.vue?vue&type=script&lang=js&"
import style0 from "./u-tab-dot.vue?vue&type=style&index=0&id=714d1266&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714d1266",
  null
  
)

export default component.exports